import { Button, Form, FormInstance } from "antd";
import { CustomModal } from "../../../../lib/CustomModal";
import { useCallback, useState } from "react";
import { FormItems } from "./components/FormItems";

export const ZipCodes = () => {
  const [form]: FormInstance[] = Form.useForm();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openModal = useCallback(() => setIsOpen(true), []);

  const closeModal = useCallback(() => {
    form.resetFields();
    setIsOpen(false);
  }, [form]);

  return (
    <>
      <Button className="pa-0" type="link" size="small" onClick={openModal}>
        Top ZIPs by Customer Count
      </Button>
      <CustomModal
        isModalOpen={isOpen}
        setIsModalOpen={closeModal}
        width={320}
        titleText="Top ZIPs by Customer Count"
        headerClass="processing-print-modal--header"
        modalClass="processing-print-modal"
      >
        <FormItems form={form} closeModal={closeModal} />
      </CustomModal>
    </>
  );
};
